import type { ReactNode } from 'react'

// Soft "data" surface: the default shell for the app's content.
export function Card({ className = '', children }: { className?: string; children: ReactNode }) {
  return <div className={`rounded-2xl border border-line bg-card shadow-soft ${className}`}>{children}</div>
}
